import React from "react";

export function ListCardSkeleton({ count = 5, variant = "doctor" }) {
  return (
    <div className={`list-skeleton list-skeleton--${variant}`}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="list-skeleton__card">
          <div className="list-skeleton__row">
            <span className="list-skeleton__block list-skeleton__block--xs" />
            <span className="list-skeleton__block list-skeleton__block--sm" />
          </div>
          <span className="list-skeleton__block list-skeleton__block--title" />
          <span className="list-skeleton__block list-skeleton__block--line" />
          <span className="list-skeleton__block list-skeleton__block--line list-skeleton__block--short" />
        </div>
      ))}
    </div>
  );
}

export function ProfileSkeleton() {
  return (
    <div className="profile-skeleton">
      <div className="profile-skeleton__hero">
        <span className="list-skeleton__block list-skeleton__block--badge" />
        <span className="list-skeleton__block list-skeleton__block--title" />
        <span className="list-skeleton__block list-skeleton__block--line" />
        <span className="list-skeleton__block list-skeleton__block--short" />
      </div>
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className="profile-skeleton__row">
          <span className="list-skeleton__block list-skeleton__block--label" />
          <span className="list-skeleton__block list-skeleton__block--value" />
        </div>
      ))}
    </div>
  );
}

export function DashboardSkeleton({ statCount = 3 }) {
  return (
    <div className="dashboard-skeleton">
      <div className="dashboard-skeleton__welcome box">
        <div className="box-body">
          <span className="list-skeleton__block dashboard-skeleton__title" />
          <span className="list-skeleton__block list-skeleton__block--line dashboard-skeleton__subtitle" />
        </div>
      </div>

      <div className="row admin-stats-grid dashboard-skeleton__stats">
        {Array.from({ length: statCount }).map((_, index) => (
          <div key={index} className="col-lg-4 col-12 admin-stat-card">
            <div className="box">
              <div className="box-body">
                <div className="dashboard-skeleton__stat">
                  <span className="list-skeleton__block dashboard-skeleton__icon" />
                  <div className="dashboard-skeleton__stat-text">
                    <span className="list-skeleton__block list-skeleton__block--line" />
                    <span className="list-skeleton__block list-skeleton__block--short" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function CasesPanelSkeleton({ cardCount = 4, variant = "case" }) {
  return (
    <div className="cases-panel-skeleton">
      <div className="cases-panel-skeleton__header">
        <div className="cases-panel-skeleton__title-row">
          <span className="list-skeleton__block cases-panel-skeleton__title" />
          <span className="list-skeleton__block cases-panel-skeleton__action" />
        </div>
        <span className="list-skeleton__block cases-panel-skeleton__search" />
      </div>
      <ListCardSkeleton count={cardCount} variant={variant} />
    </div>
  );
}

export function PageContentSkeleton({ cardCount = 3 }) {
  return (
    <div className="page-content-skeleton">
      <div className="page-content-skeleton__panel box">
        <div className="page-content-skeleton__header">
          <span className="list-skeleton__block page-content-skeleton__title" />
        </div>
        <ListCardSkeleton count={cardCount} variant="case" />
      </div>
    </div>
  );
}
